import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import { Container, Row, Col } from "reactstrap";
import drive from "../assets/all-images/cars-img/drive.svg";
import driver from "../assets/all-images/cars-img/driver.svg";
import delivery from "../assets/all-images/cars-img/delivery.svg";
import events from "../assets/all-images/cars-img/events.svg";
import "../styles/about.css";

const Service = () => {
  const fadeInUpVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeInOut" } },
  };

  const controlsDrive = useAnimation();
  const controlsDriver = useAnimation();
  const controlsDelivery = useAnimation();
  const controlsEvents = useAnimation();

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const sectionElements = document.querySelectorAll(".about__page-section");

    sectionElements.forEach((section, index) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;

      if (scrollY + windowHeight > sectionTop + sectionHeight / 2) {
        switch (index) {
          case 0:
            controlsDrive.start(fadeInUpVariants.visible);
            break;
          case 1:
            controlsDriver.start(fadeInUpVariants.visible);
            break;
          case 2:
            controlsDelivery.start(fadeInUpVariants.visible);
            break;
          case 3:
            controlsEvents.start(fadeInUpVariants.visible);
            break;
          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            controlsDrive.start(fadeInUpVariants.hidden);
            break;
          case 1:
            controlsDriver.start(fadeInUpVariants.hidden);
            break;
          case 2:
            controlsDelivery.start(fadeInUpVariants.hidden);
            break;
          case 3:
            controlsEvents.start(fadeInUpVariants.hidden);
            break;
          default:
            break;
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [controlsDrive, controlsDriver, controlsDelivery, controlsEvents]);

  return (
    <Helmet title="About">
      <CommonSection title="Our Services" />

      {/* Section 1 */}
      <section className="about__page-section">
        <Container>
          <Row>
          <h4 className="section__subtitle">Our Services</h4>
              <h2 className="section__title">Grab one of our services !</h2>
            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-img"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDrive}
              >
                <img src={drive} alt="" className="w-100 rounded-3" />
              </motion.div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-content"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDrive}
              >
                <h2 className="section__title">Self drive</h2>
                <p className="section__description">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Eveniet veniam assumenda aperiam accusantium ex autem
                  perferendis repellendus nostrum delectus. Nemo et dolore est
                  tempore rem minima adipisci magni dolorum ipsam.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section 2 */}
      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-content"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDriver}
              >
                <h2 className="section__title">Become a Driver</h2>
                <p className="section__description">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Eveniet veniam assumenda aperiam accusantium ex autem
                  perferendis repellendus nostrum delectus. Nemo et dolore est
                  tempore rem minima adipisci magni dolorum ipsam.
                </p>
              </motion.div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-img"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDriver}
              >
                <img src={driver} alt="" className="w-100 rounded-3" />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section 3 */}
      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-img"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDelivery}
              >
                <img src={delivery} alt="" className="w-100 rounded-3" />
              </motion.div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-content"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsDelivery}
              >
                <h2 className="section__title">Delivery</h2>
                <p className="section__description">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Eveniet veniam assumenda aperiam accusantium ex autem
                  perferendis repellendus nostrum delectus. Nemo et dolore est
                  tempore rem minima adipisci magni dolorum ipsam.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section 4 */}
      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-content"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsEvents}
              >
                <h2 className="section__title">Events</h2>
                <p className="section__description">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Eveniet veniam assumenda aperiam accusantium ex autem
                  perferendis repellendus nostrum delectus. Nemo et dolore est
                  tempore rem minima adipisci magni dolorum ipsam.
                </p>
              </motion.div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <motion.div
                className="about__page-img"
                variants={fadeInUpVariants}
                initial="hidden"
                animate={controlsEvents}
              >
                <img src={events} alt="" className="w-100 rounded-3" />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Service;
